<template>
  <div class="intimate-rule">
    <van-nav-bar class="van-bar" title="" :style="`paddingTop:${barHeight}px`" left-arrow @click-left="handleBack">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
        <span class="tit-left">
          {{ $t('lang.FriendshipLevel.k031') }}
        </span>
      </template>
    </van-nav-bar>
    <div class="main">
      <div class="prologue">{{ $t('lang.FriendshipLevel.k015') }}</div>
      <div class="titie1">{{ $t('lang.FriendshipLevel.k023') }}</div>
      <div class="text1">{{ $t('lang.FriendshipLevel.k018') }}</div>
      <div class="titie2">{{ $t('lang.FriendshipLevel.k016') }}</div>
      <div class="text1">{{ $t('lang.FriendshipLevel.k019') }}</div>
      <div class="titie2">{{ $t('lang.FriendshipLevel.k017') }}</div>
      <div class="text1">{{ $t('lang.FriendshipLevel.k020') }}</div>
      <div class="titie1">{{ $t('lang.FriendshipLevel.k024') }}</div>
      <div class="text1">{{ $t('lang.FriendshipLevel.k021') }}</div>
      <div class="titie1">{{ $t('lang.FriendshipLevel.k022') }}</div>
      <div class="text1">{{ $t('lang.FriendshipLevel.k014') }}</div>
    </div>
  </div>
</template>

<script>
// 亲密度规则
export default {
  created() {
    this.$client.addEvent('ep_about_bond_page')
  },
  methods: {
    handleBack() {
      const query = this.$route.query
      if (query.fromPage && query.fromPage === 'friendship-level') {
        this.$router.replace({
          path: '/friendship-level',
          query: {
            targetUid: query.targetUid
          }
        })
        return
      }

      this.closeWeb()
    }
  }
}
</script>

<style lang="less" scoped>
.intimate-rule {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;
  .main {
    height: 100%;
    padding: 16px 20px;
    color: #666666;
    line-height: 24px;
    font-size: 15px;
    .titie1 {
      font-size: 17px;
      color: #333;
      font-weight: bold;
    }
    .titie2 {
      font-size: 17px;
      color: #333;
      font-weight: bold;
    }
    .text1 {
      padding-left: 14px;
    }
  }
}
</style>
